/**
 * Числа для показа человеку — одно место на весь виджет.
 *
 * До 02.09.2026 процент печатали тремя разными способами: `toFixed(2)` в шаблоне,
 * `toFixed(2)` в пересчёте, `String().replace('.', ',')` в списке банков и
 * `toFixed(3)` в ПСК. Первые два давали «20.10%» — точку вместо запятой и
 * хвостовой ноль — прямо рядом с правильным «5,99%» из третьего. Чинить точку
 * бессмысленно: через месяц появится четвёртое место. Поэтому способ один.
 *
 * ВАЖНО: это форматирование ТЕКСТА. Проценты в CSS (`flexBasis`, `width`)
 * пишутся через `toFixed` с точкой и сюда не ходят — CSS запятую не понимает.
 */

/**
 * Число по-русски: запятая десятичным разделителем, хвостовые нули отброшены.
 * 20 → «20» · 20.1 → «20,1» · 5.99 → «5,99» · 6.500 → «6,5»
 *
 * @param maxFrac максимум знаков после запятой, лишнее округляется
 */
export function formatNum(value: number, maxFrac = 2): string {
  if (!Number.isFinite(value)) return '—';
  const fixed = value.toFixed(maxFrac);
  // Точка в `fixed` — барьер для /0+$/: «100.00» → «100.» → «100», а не «1».
  const trimmed = fixed.includes('.') ? fixed.replace(/0+$/, '').replace(/\.$/, '') : fixed;
  return trimmed.replace('.', ',');
}

/** Процент со знаком вплотную, как в вёрстке виджета: «20,1%». */
export function formatPct(value: number, maxFrac = 2): string {
  return `${formatNum(value, maxFrac)}%`;
}
